/* Produktlistan för offert (localStorage, fristående från varukorgen) och den
   lilla bekräftelserutan NVConfirm. Laddas med defer från snippets/NV-OFFERT-CORE.liquid:
   alla som använder window.NVOffert gör det vid klick eller efter DOMContentLoaded.
   Prisformatet window.NVMoney ligger kvar direkt i snippets/NV-OFFERT-CORE.liquid. */
window.NVOffert = (function () {
  var KEY = 'nv_offert_v1';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    emit();
  }

  function emit() {
    updateBadges();
    document.dispatchEvent(new CustomEvent('nv-offert:change'));
  }

  function count() {
    return read().reduce(function (sum, item) {
      if (item.utgatt) return sum;
      return sum + (parseInt(item.qty, 10) || 0);
    }, 0);
  }

  /* Utgångna produkter syns i listan men räknas inte med i summan eller beloppsgränsen */
  function totalExclCents() {
    return read().reduce(function (sum, item) {
      if (item.utgatt) return sum;
      var price = parseInt(item.price, 10) || 0;
      var qty   = parseInt(item.qty, 10) || 0;
      return sum + Math.round(price * 0.8) * qty;
    }, 0);
  }

  // Offerten bryr sig inte om lagersaldo, men en rad får högst MAX_QTY styck.
  var MAX_QTY = 99;

  function add(item) {
    if (!item || !item.vid) return;
    var list = read();
    var qty  = Math.min(MAX_QTY, parseInt(item.qty, 10) || 1);
    var found = false;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].vid) === String(item.vid)) {
        list[i].qty = Math.min(MAX_QTY, (parseInt(list[i].qty, 10) || 0) + qty);
        /* Läggs produkten till igen gäller dagens pris, namn och bild från produktsidan */
        if (parseInt(item.price, 10)) list[i].price = parseInt(item.price, 10);
        if (item.title) list[i].title = item.title;
        if (item.variant) list[i].variant = item.variant;
        if (item.img) list[i].img = item.img;
        if (item.sku) list[i].sku = item.sku;
        if (item.handle) list[i].handle = item.handle;
        delete list[i].utgatt;
        found = true;
        break;
      }
    }
    if (!found) {
      list.push({
        vid: String(item.vid),
        handle: item.handle || '',
        title: item.title || '',
        variant: item.variant || '',
        sku: item.sku || '',
        price: parseInt(item.price, 10) || 0,
        img: item.img || '',
        qty: qty,
        note: ''
      });
    }
    write(list);
  }

  function setQty(vid, qty) {
    qty = Math.min(MAX_QTY, parseInt(qty, 10) || 0);
    var list = read().filter(function (item) {
      if (String(item.vid) !== String(vid)) return true;
      item.qty = qty;
      return qty > 0;
    });
    write(list);
  }

  function setNote(vid, text) {
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].vid) === String(vid)) {
        list[i].note = text || '';
        break;
      }
    }
    // Ingen emit här, anteckningar skrivs medan kunden skriver och ska
    // inte rita om listan under fingrarna.
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function remove(vid) {
    write(read().filter(function (item) { return String(item.vid) !== String(vid); }));
  }

  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    emit();
  }

  /* ---- Dagens pris och status för raderna ----
     Priset sparas när produkten läggs till. När offerten visas hämtas
     /products/{handle}.js för varje produkt (samtidigt), och raderna får
     dagens pris, namn, variantnamn, artikelnummer och bild. Svarar adressen
     404 (produkten finns inte) eller saknas varianten i svaret markeras raden
     som utgången. En slutsåld variant räknas inte som utgången.
     Nätverksfel och andra fel ändrar ingenting.
     Shopifys .js ger priset i öre inkl. moms, samma enhet som vi sparar. */
  function imgKey(url) {
    var path = String(url || '').split('?')[0];
    return path.substring(path.lastIndexOf('/') + 1);
  }
  function sized(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
  }
  var senastHamtat = 0;
  var pagar = null;
  function refresh() {
    if (pagar) return pagar;
    if (Date.now() - senastHamtat < 60000) return Promise.resolve();
    var handles = [];
    read().forEach(function (item) {
      if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });
    if (!handles.length || typeof fetch !== 'function') return Promise.resolve();
    pagar = Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (r.status === 404) return { handle: h, borta: true };
          if (!r.ok) return null;
          return r.json().then(function (p) { return { handle: h, produkt: p }; });
        })
        .catch(function () { return null; });
    })).then(function (svar) {
      var info = {};
      svar.forEach(function (s) { if (s) info[s.handle] = s; });
      var list = read();
      var andrad = false;
      list.forEach(function (item) {
        var s = info[item.handle];
        if (!s) return;
        var utgatt = false;
        var pris = parseInt(item.price, 10) || 0;
        if (s.borta) {
          utgatt = true;
        } else {
          var p = s.produkt || {};
          var v = (p.variants || []).filter(function (x) { return String(x.id) === String(item.vid); })[0];
          if (!v) utgatt = true;
          else {
            if (parseInt(v.price, 10) >= 0) pris = parseInt(v.price, 10);
            var nytt = {
              title: p.title || item.title || '',
              variant: v.title || item.variant || '',
              sku: v.sku || ''
            };
            var bild = (v.featured_image && v.featured_image.src) || p.featured_image || '';
            if (bild && imgKey(bild) !== imgKey(item.img)) nytt.img = sized(bild);
            Object.keys(nytt).forEach(function (k) {
              if (nytt[k] !== (item[k] || '')) { item[k] = nytt[k]; andrad = true; }
            });
          }
        }
        if (pris !== (parseInt(item.price, 10) || 0)) { item.price = pris; andrad = true; }
        if (!!item.utgatt !== utgatt) {
          if (utgatt) item.utgatt = true; else delete item.utgatt;
          andrad = true;
        }
      });
      if (andrad) write(list);
    }).catch(function () {}).then(function () {
      senastHamtat = Date.now();
      pagar = null;
    });
    return pagar;
  }

  function formatKr(cents) {
    return window.NVMoney.format(cents);
  }

  function updateBadges() {
    var n = count();
    document.querySelectorAll('[data-nv-offert-count]').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      el.classList.toggle('is-visible', n > 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBadges);
  } else {
    updateBadges();
  }

  // Håller flikar i synk om kunden har butiken öppen på flera ställen.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) emit();
  });

  return {
    read: read,
    add: add,
    setQty: setQty,
    setNote: setNote,
    remove: remove,
    clear: clear,
    count: count,
    totalExclCents: totalExclCents,
    refresh: refresh,
    maxQty: MAX_QTY,
    formatKr: formatKr
  };
})();

/* ---- Liten bekräftelseruta vid knappen i stället för webbläsarens stora ruta ----
   Används av offerten, varukorgssidan och varukorgspanelen:
   NVConfirm(knapp, 'Ta bort produkten från offerten?', 'Ta bort').then(function (ja) { ... })
   Ligger knappen i en panel med aria-modal="true" läggs rutan i panelen, så att
   Tab-fällan når den. Panelen har transform, därför placeras rutan absolut i
   panelen (räknat från panelens läge och scroll) i stället för fixed.
   NVConfirm.check() stänger rutan om knappen den hör till har ritats om. */
window.NVConfirm = (function () {
  var pop = null, done = null, anchor = null, host = null;
  var ticking = false;

  function injectStyle() {
    if (document.getElementById('nv-confirm-style')) return;
    var st = document.createElement('style');
    st.id = 'nv-confirm-style';
    st.textContent =
      '.nv-confirm{position:fixed;z-index:100010;display:flex;align-items:center;gap:10px;box-sizing:border-box;max-width:calc(100vw - 16px);padding:6px;background:#FFFFFF;border:1px solid #F0F0F0;border-radius:16px;box-shadow:1px 1px 4px rgba(0,0,0,0.08);color:#000000;font-size:var(--nv-fs-small);line-height:1.3;animation:nv-confirm-in .2s ease both}@media (prefers-reduced-motion:reduce){.nv-confirm{animation:none}}' +
      '.nv-confirm--in-panel{position:absolute}' +
      '@keyframes nv-confirm-in{from{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}' +
      '.nv-confirm__text{margin:0;font-weight:700;white-space:nowrap}' +
      '.nv-confirm__actions{display:flex;gap:2px}' +
      '.nv-confirm .nv-confirm__btn{height:auto;min-height:36px;min-width:0;margin:0;padding:0 10px;border:0;border-radius: 16px;box-shadow:none;outline:0;font-family:inherit;font-size:var(--nv-fs-small);font-weight:700;letter-spacing:0;line-height:1;text-transform:none;cursor:pointer;transition:background-color .4s cubic-bezier(0.28,0.11,0.32,1)}' +
      '.nv-confirm .nv-confirm__btn--cancel,.nv-confirm .nv-confirm__btn--cancel:focus-visible{background:transparent;color:#000000}' +
      '.nv-confirm .nv-confirm__btn--ok,.nv-confirm .nv-confirm__btn--ok:focus-visible{background:#4F772D;color:#FFFFFF}' +
      '.nv-confirm .nv-confirm__btn:focus-visible{box-shadow:none;outline:0}' +
      '.nv-confirm .nv-confirm__btn:focus-visible{outline:2px solid rgba(79,119,45,0.4);outline-offset:1px}' +
      '@media (max-width:999px){.nv-confirm__actions{gap:8px}.nv-confirm .nv-confirm__btn{min-height:44px;padding:0 14px}}' +
      '@media (min-width:1000px){.nv-confirm .nv-confirm__btn--cancel:hover{background:#F9F9F9;color:#000000}.nv-confirm .nv-confirm__btn--ok:hover{background:#90A955;color:#FFFFFF}}' +
      '@media (prefers-reduced-motion:reduce){.nv-confirm{animation:none}}';
    document.head.appendChild(st);
  }

  function place() {
    ticking = false;
    if (!pop || !anchor) return;
    if (!document.body.contains(anchor)) { close(false, true); return; }
    var r = anchor.getBoundingClientRect();
    var w = pop.offsetWidth, h = pop.offsetHeight;
    var minX = 8, maxX = document.documentElement.clientWidth - 8;
    var minY = 8, maxY = window.innerHeight - 8;
    var offX = 0, offY = 0;
    if (host !== document.body) {
      var pr = host.getBoundingClientRect();
      minX = Math.max(minX, pr.left + 8);
      maxX = Math.min(maxX, pr.right - 8);
      minY = Math.max(minY, pr.top + 8);
      maxY = Math.min(maxY, pr.bottom - 8);
      offX = pr.left + host.clientLeft - host.scrollLeft;
      offY = pr.top + host.clientTop - host.scrollTop;
    }
    var left = Math.min(Math.max(minX, r.right - w), maxX - w);
    var top = r.bottom + 8;
    if (top + h > maxY) top = Math.max(minY, r.top - h - 8);
    pop.style.left = (left - offX) + 'px';
    pop.style.top = (top - offY) + 'px';
  }
  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(place);
  }

  function outside(e) { if (pop && !pop.contains(e.target)) close(false); }
  function onKey(e) {
    if (!pop || e.key !== 'Escape') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    close(false);
  }
  // Fokus lämnar rutan (Tab vidare): stäng utan att flytta tillbaka fokus
  function onFocusOut(e) {
    if (pop && e.relatedTarget && !pop.contains(e.relatedTarget)) close(false, true);
  }

  function close(result, keepFocus) {
    if (!pop) return;
    pop.removeEventListener('focusout', onFocusOut);
    pop.parentNode && pop.parentNode.removeChild(pop);
    pop = null;
    host = null;
    document.removeEventListener('pointerdown', outside, true);
    window.removeEventListener('keydown', onKey, true);
    window.removeEventListener('scroll', schedule, { capture: true, passive: true });
    window.removeEventListener('resize', schedule);
    var cb = done, a = anchor;
    done = null; anchor = null;
    if (!keepFocus && a && document.body.contains(a) && a.focus) { try { a.focus({ preventScroll: true }); } catch (err) {} }
    if (cb) cb(result);
  }

  function confirm(el, message, okText) {
    if (pop) close(false, true);
    injectStyle();
    anchor = el;
    var panel = el && el.closest ? el.closest('[aria-modal="true"]') : null;
    host = panel || document.body;
    pop = document.createElement('div');
    pop.className = 'nv-confirm' + (panel ? ' nv-confirm--in-panel' : '');
    pop.setAttribute('role', 'alertdialog');
    // Ingen synlig fråga, bara knapparna. Frågan finns kvar för skärmläsare.
    pop.setAttribute('aria-label', message || 'Ta bort?');
    var actions = document.createElement('div');
    actions.className = 'nv-confirm__actions';
    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'nv-confirm__btn nv-confirm__btn--cancel';
    no.textContent = 'Avbryt';
    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'nv-confirm__btn nv-confirm__btn--ok';
    yes.textContent = okText || 'Ta bort';
    actions.appendChild(no);
    actions.appendChild(yes);
    pop.appendChild(actions);
    pop.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target === yes) close(true);
      else if (e.target === no) close(false);
    });
    pop.addEventListener('focusout', onFocusOut);
    host.appendChild(pop);
    place();
    // Avbryt får fokus först, så att Enter inte tar bort av misstag
    no.focus({ preventScroll: true });
    document.addEventListener('pointerdown', outside, true);
    window.addEventListener('keydown', onKey, true);
    window.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule);
    return new Promise(function (resolve) { done = resolve; });
  }

  confirm.check = function () {
    if (pop && anchor && !document.body.contains(anchor)) close(false, true);
  };
  return confirm;
})();
